// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"817":"0f9580cbf182ec9c","3278":"44a4f8d4be48a9c4"}[chunkId] + ".css";
};